<mat-toolbar color="warn" style="height: 40px;">
  <span class="example-spacer"></span>
  Show only active&nbsp;
  <mat-checkbox (change)="refresh($event.checked)" checked>
  </mat-checkbox>
</mat-toolbar>
<table mat-table [dataSource]="punishments">
  <ng-container matColumnDef="player">
    <th mat-header-cell *matHeaderCellDef>Player</th>
    <td mat-cell *matCellDef="let p" routerLink="/players/{{p.player.uuid}}">
      <span style="display: flex; align-items: center">
        <img src="https://mc-heads.net/avatar/{{p.player.uuid}}/20"> &nbsp;
        {{p.player.lastUsername}}
      </span>
    </td>
  </ng-container>
  <ng-container matColumnDef="mod">
    <th mat-header-cell *matHeaderCellDef>Moderator</th>
    <td mat-cell *matCellDef="let p" routerLink="/players/{{p.moderator.uuid}}">
      <span style="display: flex; align-items: center">
        <img src="https://mc-heads.net/avatar/{{p.moderator.uuid}}/20"> &nbsp;
        {{p.moderator.lastUsername}}
      </span>
    </td>
  </ng-container>
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef>Type</th>
    <td mat-cell *matCellDef="let p">
      {{p.type}}
    </td>
  </ng-container>
  <ng-container matColumnDef="reason">
    <th mat-header-cell *matHeaderCellDef>Reason</th>
    <td mat-cell *matCellDef="let p">
      {{p.reason}}
    </td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let p">
      <span *ngIf="p.quashed" style="display: flex; align-items: center">
        Overturned by &nbsp;
        <img src="https://mc-heads.net/avatar/{{p.quashedBy!.uuid}}/20"> &nbsp;
        {{p.quashedBy!.lastUsername}}
      </span>
      <span style="display: flex; align-items: center" *ngIf="!p.quashed">
        {{getStatus(p)}}&nbsp;
        <button mat-icon-button *ngIf="isActive(p) && apiService.hasEntitlement(authService.user!.entitlements, 'MODERATION')" matTooltip="Revert this punishment and un{{p.type.toLowerCase()}} the player" (click)="quash(p)">
          <mat-icon>undo</mat-icon>
        </button>
      </span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>
